'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useOverlayHistory } from '@/hooks/useOverlayHistory';
const SpinBackEntry = t0 => {
  const {
    onBack
  } = t0;
  useOverlayHistory(true, onBack);
  return null;
};

//* 회전 중 뒤로가기는 마커만 소비하고 페이지는 남는다 — 키를 갈아 마커를 다시 세워야 다음 뒤로가기도 막힌다
export const RouletteSpinBackGuard = () => {
  const $ = _c(5);
  const [rearmCount, setRearmCount] = useState(0);
  let t0;
  if ($[0] !== rearmCount) {
    t0 = () => setRearmCount(rearmCount + 1);
    $[0] = rearmCount;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== rearmCount || $[3] !== t0) {
    t1 = <SpinBackEntry key={rearmCount} onBack={t0} />;
    $[2] = rearmCount;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};